import instance from '../../api/instance'
const path = '/wv/chatbots'

export default {
    async references(faqIds) {
        return await instance(window.config['application_host']).get(path + `/llm_references?faq_ids=${faqIds.join(",")}`)
    },
    async logChatMessage(message, sender, extra={}) {
        return await instance(window.config['application_host']).get(path + `/log_chat_message?message=${message}&sender=${sender}&extra=${JSON.stringify(extra)}`)
    }
}